import EmojiRatingPage from "@components/EmojiRatingPage"

export default function HairstyleBoldLooksPage() {
  return (
    <EmojiRatingPage
      translationKey="boldLooksHairstyle"
      leftLabelKey="playItSafe"
      rightLabelKey="superBold"
    />
  )
}
